import { Flex } from '@chakra-ui/react'

import CourseQ from '@/queries/CourseQ'
import { AP_REVIEW_COURSE } from '@/queries/constants'
import TopicQ from '@/queries/TopicQ'
import { useQuery } from '@/client/context/query'
import type { Query } from '@/client/query'
import { getCourseUrlBySlug } from '@/client/services/url'

import ShwLink from '@/components/ShwLink'

// Custom function needed here because we don't want redirect, we want to stay in the course page but add new topic queries
function getTopicUrl(topic: Query) {
  const course = topic.one(TopicQ.getCourse())
  return `/course/${course(CourseQ.slug)}?topics=${topic(TopicQ.id)}`
}

export const CourseSubheader: React.FC<{
  courseName: string
}> = ({ courseName }) => {
  const query = useQuery()

  const calculusCourse = getCourseUrlBySlug(
    `${query.one(CourseQ.getByName('Calculus'))(CourseQ.slug)}`
  )
  const statisticsCourse = getCourseUrlBySlug(
    `${query.one(CourseQ.getByName('Statistics'))(CourseQ.slug)}`
  )
  const chemistryTopic = getTopicUrl(query.one(TopicQ.getByName('Chemistry')))
  const biologyTopic = getTopicUrl(query.one(TopicQ.getByName('Biology')))
  const physicsTopic = getTopicUrl(query.one(TopicQ.getByName('Physics')))
  const computerScienceTopic = getTopicUrl(query.one(TopicQ.getByName('Computer Science')))

  if (courseName === 'Community') {
    return (
      <Flex pt={4} mb={6}>
        <div>
          Make global friendships and let your voice be heard within Schoolhouse.world community
          sessions.
        </div>
      </Flex>
    )
  }

  if (courseName === 'Experimental') {
    return (
      <Flex pt={4} mb={6}>
        <div>
          Special topics in Science, Computer Science, and more! We&apos;re still experimenting and
          do not yet offer formal tutoring certification for these topics.
        </div>
      </Flex>
    )
  }

  if (courseName === 'Indian Exams') {
    return (
      <Flex pt={4} mb={6}>
        <div>Free coaching sessions for JEE, CBSE, ICSE, and more!</div>
      </Flex>
    )
  }

  if (courseName === AP_REVIEW_COURSE) {
    return (
      <Flex pt={4} mb={6}>
        <div>
          Need help with the core concepts underlying these AP® exams? Get additional support by
          checking out general sessions in: <ShwLink href={calculusCourse}>Calculus</ShwLink>,{' '}
          <ShwLink href={statisticsCourse}>Statistics</ShwLink>,{' '}
          <ShwLink href={chemistryTopic}>Chemistry</ShwLink>,{' '}
          <ShwLink href={biologyTopic}>Biology</ShwLink>,{' '}
          <ShwLink href={physicsTopic}>Physics</ShwLink>, and{' '}
          <ShwLink href={computerScienceTopic}>Computer Science</ShwLink>.
        </div>
      </Flex>
    )
  }

  return null
}
